<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Daily Tasks
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'DailyTaskCreate'}">
          <button class="btn btn-success">Create Daily Task</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="daily_tasks" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'DailyTaskEdit', params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "DailyTasks",
  data() {
    return {
      daily_tasks: [],
      columns: ["id", "category_name", "topic_name","game_count","coins","gems", "start_time", "end_time", "action"],
      options: {
        pagination: {nav: "fixed"},
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    }
  },
  created() {
    this.getDailyTasks();
  },
  methods: {
    getDailyTasks() {
      this.$axios
          .get(`${ADMIN_URL}/daily-tasks`)
          .then((response) => {
            this.daily_tasks = response.data;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    }
  }
}
</script>

<style scoped>

</style>
